import { render, staticRenderFns } from "./selaReserveStats.vue?vue&type=template&id=2cadbb33&scoped=true"
import script from "./selaReserveStats.vue?vue&type=script&lang=js"
export * from "./selaReserveStats.vue?vue&type=script&lang=js"
import style0 from "./selaReserveStats.vue?vue&type=style&index=0&id=2cadbb33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadbb33",
  null
  
)

export default component.exports